import { render, staticRenderFns } from "./myworks.vue?vue&type=template&id=5095a876&"
import script from "./myworks.vue?vue&type=script&lang=js&"
export * from "./myworks.vue?vue&type=script&lang=js&"
import style0 from "./myworks.vue?vue&type=style&index=0&id=5095a876&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5095a876')) {
      api.createRecord('5095a876', component.options)
    } else {
      api.reload('5095a876', component.options)
    }
    module.hot.accept("./myworks.vue?vue&type=template&id=5095a876&", function () {
      api.rerender('5095a876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/myworks.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/myworks.vue
// module id = K6kr
// module chunks = 0